import React, { useEffect } from 'react';
import Header from '../parts/Header';

import step_logo_first from '../../assets/img/step-logo-first.svg'
import step_logo_second from '../../assets/img/step-logo-second.svg'
import step_logo_third from '../../assets/img/step-logo-third.svg'
 
function InstructionPage (){
    
    useEffect(() => {
        //Mounted
    }, []);
    
    return (
        <>
        <Header />
        <div className="cf-manual-instruction">

            <section className="payment-step-section">
                <div className="container">
                    <div className='row d-flex justify-content-center'>
                        <div className='col-lg-8'>
                            <h2 className="text-dark-second">
                            Over-the-Counter Donation
                            </h2>
                            <div className="step-row-container  bg-off-orange">
                                <div className="step-row-container-img">
                                    <img src={step_logo_first} className="img-fluid" />
                                </div>
                                <div className="step-row-container-content">
                                    <p className="text-large">
                                    <b>Step 1.</b> Donate through any of the following banks.
                                    </p>
                                    <p className="text-large">
                                    Account Name: World Vision Development Foundation
                                    </p>
                                    <ul>
                                    <li>
                                        <p className="text-large no-margin-bottom"><span className="text-blue">BPI</span> Account No.
                                        4251-0024-15</p>
                                    </li>
                                    <li>
                                        <p className="text-large no-margin-bottom"><span className="text-blue">BDO</span> Account No.
                                        000-2700-4341-1</p>
                                    </li>
                                    <li>
                                        <p className="text-large no-margin-bottom"><span className="text-blue">PS Bank</span> Account No.
                                        038-33200-0138</p>
                                    </li>
                                    <li>
                                        <p className="text-large no-margin-bottom"><span className="text-blue">Metrobank</span> Account No.
                                        060-7060-5186-41
                                        </p>
                                    </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="step-row-container  bg-off-orange">
                                <div className="step-row-container-img">
                                    <img src={step_logo_second} className="img-fluid" />
                                </div>
                                <div className="step-row-container-content">
                                    <p className="text-large">
                                    <b>Step 2.</b> Kindly send clear scanned copy or photo of the bank deposit slip to <a href="mailto:wvphilippines@wvi.org" className="text-primary">wvphilippines@wvi.org</a> along
                                    with the following
                                    details so we can properly acknowledge your pledge.
                                    </p>
                                    <ul>
                                    <li>
                                        <p className="no-margin-bottom text-large">
                                        Your complete name
                                        </p>
                                    </li>
                                    <li>
                                        <p className="no-margin-bottom text-large">
                                        Your mobile number
                                        </p>
                                    </li>
                                    <li>
                                        <p className="no-margin-bottom text-large">
                                        Transaction date
                                        </p>
                                    </li>
                                    <li>
                                        <p className="no-margin-bottom text-large">
                                        Amount and cause
                                        </p>
                                    </li>
                                    <li>
                                        <p className="no-margin-bottom text-large">
                                        Bank and branch
                                        </p>
                                    </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="step-row-container  bg-off-orange">
                                <div className="step-row-container-img">
                                    <img src={step_logo_third} className="img-fluid" />
                                </div>
                                <div className="step-row-container-content">
                                    <p className="text-large mb-0">
                                    <b>Step 3:</b> A World Vision representative will acknowledge your donation within 1-2 business
                                    days.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="other-payment-section">
                <div className="container">
                    <div className='row d-flex justify-content-center'>
                        <div className='col-lg-8'>
                            <h2 className="text-dark-second">
                            Cebuana Lhuillier or Bayad Center
                            </h2>
                            <div className="other-payment-step-container">
                            <div className="other-payment-step-row">
                                <div className="other-payment-step-row-number">
                                <div className="row-number-w-bg">
                                    <h4>
                                    1
                                    </h4>
                                </div>
                                </div>
                                <div className="other-payment-step-row-content">
                                <p className="text-large no-margin-bottom">
                                    Please email us at <a href="mailto:wvphilippines@wvi.org" className="text-primary"><u>wvphilippines@wvi.org</u></a> or call us at (02)8374-7618 loc
                                    214
                                    to request your Partner ID number.
                                </p>
                                </div>
                            </div>
                            <div className="other-payment-step-row">
                                <div className="other-payment-step-row-number">
                                <div className="row-number-w-bg">
                                    <h4>
                                    2
                                    </h4>
                                </div>
                                </div>
                                <div className="other-payment-step-row-content">
                                <p className="text-large no-margin-bottom">
                                    Provide your World Vision Partner ID number to Cebuana Lhuillier or Bayad Center when giving
                                    your donations.
                                </p>
                                </div>
                            </div>
                            <div className="other-payment-step-row">
                                <div className="other-payment-step-row-number">
                                <div className="row-number-w-bg">
                                    <h4>
                                    3
                                    </h4>
                                </div>
                                </div>
                                <div className="other-payment-step-row-content">
                                <p className="text-large no-margin-bottom">
                                    Send a clear photo or scanned copy of your receipt to <a href="mailto:wvphilippines@wvi.org" className="text-primary">wvphilippines@wvi.org</a> and use your complete name as email
                                    subject.
                                </p>
                                </div>
                            </div>
                            <div className="other-payment-step-row">
                                <div className="other-payment-step-row-number">
                                <div className="row-number-w-bg">
                                    <h4>
                                    4
                                    </h4>
                                </div>
                                </div>
                                <div className="other-payment-step-row-content">
                                <p className="text-large no-margin-bottom">
                                    A World Vision representative will acknowledge your donation within 1-2 business days.
                                </p>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </div>
        </>
    )
}
 
export default InstructionPage;